import * as React from "react";
import Typography from "@mui/material/Typography";
import "./PowerBI.css";
import PowerBIPricing from "./PowerBIPricing";

const PowerBIPlansAndFeatures: React.FC = () => {
  return (
    <>
      <div className={"gap4rem flex-col"}>
        <div className={"gap1rem flex-col"}>
          <Typography
            variant="h4"
            fontSize="2.125rem"
            fontWeight={600}
            component="div"
            sx={{
              color: "#0A85C7",
              lineHeight: "2.25rem",
              padding: "0.625rem 0",
            }}
          >
            Pricing Plans and Features
          </Typography>
          <div className={"gap2rem flex-row"}>
            <div className={"gap1rem flex-col"}>
              <Typography
                variant="h6"
                fontSize="1.25rem"
                sx={{ color: "#02273C", lineHeight: "1.5rem" }}
              >
                Power BI includes
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: "#02273C", lineHeight: "1.5rem" }}
              >
                {" "}
                <ul>
                  <li>AI-Powered Data Insights</li>
                  <li>Data Integration with Multiple Sources</li>
                  <li>Customizable Dashboards and Reports</li>
                  <li>Role-Based Data Access</li>
                  <li>Real-Time Data Monitoring</li>
                  <li>Advanced Data Analytics Tools</li>
                  <li>Collaboration and Sharing Capabilities</li>
                  <li>Natural Language Query Support</li>
                  <li>Automated Data Refresh</li>
                  <li>Seamless Cloud Integration</li>
                </ul>
              </Typography>
            </div>
          </div>
          <PowerBIPricing title={"Plan Options & Details"} />
        </div>
      </div>
    </>
  );
};

export default PowerBIPlansAndFeatures;
